import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import RezultataiClass from '../clases/rezultatai';
import useBendriRezultatai from './useBendriRezultatai';
import { useRezultatai } from './useRezultatai';

export const useTendencijosData = (tipai = [], info = [], pilnaInfo = [], filtersMain = {}) => {
    const { t } = useTranslation();

    const [data, setData] = useState({
        puslapiai: {},
        pavadinimai: [],
        pagalMetus: {},
        visi: {},
        visiPilni: {},
        visiNauji: {},
        visiNaujiBendri: {},
        bendrasAts: {},
        bendrasPilnas: {}
    });
    // Metų filtro gavimas
    const metaiFilter = useMemo(() => {
        return filtersMain?.metai ? Number(filtersMain.metai) : null;
    }, [filtersMain?.metai]);

    const { data: commonResultsData, isLoading: isLoadingBendriRezultatai } = useRezultatai({
        formosTipas: filtersMain.type,
        kasPildo: filtersMain.kasPildo,
        metai: metaiFilter
    });

    // Naudojame bendrų rezultatų hook'ą
    const { 
        hasBendrusRezultatus
    } = useBendriRezultatai();



    const Rezai = useMemo(() => new RezultataiClass({
        nerodyti: {
            pages: t('pslNerodo'),
            questions: t('questionNerodyti')
        }
    }), [t]);

    useEffect(() => {
                const newData = {
                    pavadinimai: [],
                    puslapiai: {},
                    pagalMetus: {},
                    visi: {},
                    visiPilni: {},
                    visiNauji: {},
                    visiNaujiBendri: {},
                    bendrasAts: {},
                    bendrasPilnas: {}
                };

                if (Array.isArray(tipai) && Array.isArray(info) && tipai.length > 0 && info.length > 0) {
                    newData.pavadinimai = Rezai.puslapiuPavadinimai(tipai);
                    newData.puslapiai = Rezai.puslapiaiIsTipu(tipai);
                    
                    newData.pagalMetus = Rezai.datomParuostiAtsakymai(info);

                    const allTipai = tipai;
                    
                    newData.visi = Rezai.klausimuAtsakymai(info, allTipai);
                    
                    // Skaičiuojame tik konkrečios įmonės rezultatus
                    newData.visiNauji = Rezai.visiAts(allTipai, info);
                    
                    // Optimizuota bendrų rezultatų užklausa - darome tik vieną patikrinmą
                    // ir vieną užklausą vietoj dviejų identiskų kodinių blokų
                    const hasCommonResults = hasBendrusRezultatus({
                        formosTipas: filtersMain.type || 'Darbuotojo forma',
                        kasPildo: filtersMain.kasPildo || 'Darbuotojai',
                        metai: metaiFilter
                    });
                    
                    
                    if (hasCommonResults) {
                        try {
                            if (commonResultsData && commonResultsData.rezultatai) {
                                // Naudojame iš anksto apskaičiuotus bendrus rezultatus
                                newData.visiNaujiBendri = commonResultsData.rezultatai;
                            } else {
                                // Jei nėra bendrų rezultatų, skaičiuojame iš visų duomenų (tik jei turime pilnaInfo)
                                if (Array.isArray(pilnaInfo) && pilnaInfo.length > 0) {
                                    newData.visiNaujiBendri = Rezai.visiAts(allTipai, pilnaInfo);
                                }
                            }
                        } catch (error) {
                            console.error('Klaida gaunant bendrus rezultatus:', error);
                            // Jei nepavyko gauti bendrų rezultatų, bandome skaičiuoti vietoje
                            if (Array.isArray(pilnaInfo) && pilnaInfo.length > 0) {
                                newData.visiNaujiBendri = Rezai.visiAts(allTipai, pilnaInfo);
                            }
                        }
                    } else {
                        // Jei nėra bendrų rezultatų, skaičiuojame iš visų duomenų (tik jei turime pilnaInfo)
                        if (Array.isArray(pilnaInfo) && pilnaInfo.length > 0) {
                            newData.visiNaujiBendri = Rezai.visiAts(allTipai, pilnaInfo);
                        }
                    }

                    if (Array.isArray(tipai) && tipai.length > 0) {
                        const years = Object.keys(newData.visi || {});
                        
                        if (years.length > 0 && Array.isArray(info)) {
                            years.forEach(year => {
                                const yearAnswers = info.filter(answer => {
                                    if (!answer?.attributes?.uzpildymoData) return false;
                                    const date = new Date(answer.attributes.uzpildymoData);
                                    return date && !isNaN(date) && date.getFullYear().toString() === year;
                                });
                                
                                if (yearAnswers.length > 0) {
                                    const result = Rezai.bendrasAtsakymas(yearAnswers, tipai);
                                    if (result !== undefined && result !== '') {
                                        newData.bendrasAts[year] = result;
                                    }
                                }
                            });

                            // Bendram palyginimui naudojame jau turimą commonResultsData, jei turime
                            if (commonResultsData && commonResultsData.rezultatai) {
                                // Jau turime bendrų rezultatų duomenis, nebereikia nieko daryti
                            } else {
                                // Skaičiuojame tik jei neturime duomenų iš duomenų bazės ir turime pilnaInfo
                                if (Array.isArray(pilnaInfo) && pilnaInfo.length > 0) {
                                    years.forEach(year => {
                                        const yearAnswers = pilnaInfo.filter(answer => {
                                            if (!answer?.attributes?.uzpildymoData) return false;
                                            const date = new Date(answer.attributes.uzpildymoData);
                                            return date && !isNaN(date) && date.getFullYear().toString() === year;
                                        });
                                        
                                        if (yearAnswers.length > 0) {
                                            const result = Rezai.bendrasAtsakymas(yearAnswers, tipai);
                                            if (result !== undefined && result !== '') {
                                                newData.bendrasPilnas[year] = result;
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                }

                setData(newData);

    }, [tipai, info, pilnaInfo, Rezai, filtersMain.kasPildo, filtersMain.imonesPavadinimas, filtersMain.type, metaiFilter, hasBendrusRezultatus, commonResultsData]);

    return {
        data,
        loading: isLoadingBendriRezultatai,
        Rezai
    };
};

export default useTendencijosData;
